import { render, staticRenderFns } from "./ReviewRequest.vue?vue&type=template&id=cda805c6&scoped=true"
import script from "./ReviewRequest.vue?vue&type=script&lang=js"
export * from "./ReviewRequest.vue?vue&type=script&lang=js"
import style0 from "./ReviewRequest.vue?vue&type=style&index=0&id=cda805c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda805c6",
  null
  
)

export default component.exports